/**
 * 共通機能（admin/user両方で使用）のMixpanel分析設定
 *
 * このファイルには共通機能のフォーム設定を定義します：
 * - チャット機能（管理者・ユーザー両方が使用）
 * - 共通ダイアログ
 * - その他、役割を問わず使用される機能
 */

import type { TrackedFormMeta } from '@/constants/mixpanel/types'

import { Feature, Action, EventName } from '@/constants/mixpanel/constants'

/**
 * 共通機能のフォーム分析設定
 */
export const CommonForms = {
  // チャット関連（管理者・ユーザー両方が使用）
  Chat: {
    CreateRoom: {
      feature: Feature.Chat,
      action: Action.Create,
      event: EventName.FormSubmitted,
      form_type: 'create_room',
    } as TrackedFormMeta,
    SendMessage: {
      feature: Feature.Chat,
      action: Action.Create,
      event: EventName.FormSubmitted,
      form_type: 'send_message',
    } as TrackedFormMeta,
    UpdateMessage: {
      feature: Feature.Chat,
      action: Action.Update,
      event: EventName.FormSubmitted,
      form_type: 'edit_message',
    } as TrackedFormMeta,
  },
  // 招待関連（管理者が招待を送信）
  Invitation: {
    InviteUser: {
      feature: Feature.Invitation,
      action: Action.Create,
      event: EventName.FormSubmitted,
      form_type: 'send_user_invitation',
    } as TrackedFormMeta,
  },
  // ドキュメント
  Document: {
    Upsert: {
      feature: Feature.Document,
      action: Action.Upsert,
      event: EventName.FormSubmitted,
      form_type: 'create_document',
    } as TrackedFormMeta,
    UpdatePermission: {
      feature: Feature.Document,
      action: Action.Update,
      event: EventName.FormSubmitted,
      form_type: 'update_document_permission',
    } as TrackedFormMeta,
  },
} as const
